<div class="payment-issue-page">
    <div class="step-text mb-4">
        <h2 class="step-title">
            Stato abbonamento: <span class="gradient-text">pagamento non riuscito</span>
        </h2>
        <span class="step-subtitle">
            <i class="bi bi-exclamation-triangle"></i>
            <ng-container *ngIf="companyStatus === 'paymentFailed'">Il pagamento automatico non e andato a buon fine.</ng-container>
            <ng-container *ngIf="companyStatus === 'pendingPayment'">Il pagamento e ancora in sospeso.</ng-container>
            Puoi riprovare ora o cambiare metodo di pagamento.
        </span>
    </div>

    <div class="welldone-card shadow-sm" *ngIf="!loading">
        <div class="welldone-card-header d-flex justify-content-between align-items-center">
            <span>Abbonamento attuale</span>
            <span class="badge badge-error" *ngIf="companyStatus === 'paymentFailed'">Pagamento fallito</span>
            <span class="badge badge-warning" *ngIf="companyStatus === 'pendingPayment'">Pagamento in sospeso</span>
        </div>
        <div class="welldone-card-body">
            <div class="plan-name">{{ currentPlanName }}</div>
            <div class="plan-period">Frequenza: {{ currentBillingPeriodLabel }}</div>
        </div>
    </div>

    <div class="actions mt-4" *ngIf="mode === 'none'">
        <button class="btn btn-primary px-4" (click)="retryPayment()" [disabled]="!canRetryPayment || retryLoading">
            {{ retryLoading ? 'Tentativo in corso...' : 'Riprova pagamento' }}
        </button>
        <button class="btn welldone-btn-light px-4" (click)="openChangePaymentMethod()">
            Cambia metodo di pagamento
        </button>
    </div>

    <div class="alert alert-warning mt-3" *ngIf="mode === 'none' && !canRetryPayment">
        Non e stato possibile leggere il piano attuale. Usa "Cambia metodo di pagamento" o contatta il supporto.
    </div>

    <ng-container *ngIf="mode === 'changeMethod'">
        <div class="step-text mb-3 mt-4">
            <h2 class="step-title">Cambia <span class="gradient-text">metodo di pagamento</span></h2>
            <span class="step-subtitle"><i class="bi bi-credit-card-2-front"></i> Inserisci un nuovo metodo di pagamento.</span>
        </div>
        <app-stripe-embedded-checkout
            [updatePaymentMode]="true"
            [companyId]="companyId"
            (paymentCompleted)="onPaymentCompleted()">
        </app-stripe-embedded-checkout>
        <div class="actions mt-3">
            <button class="btn welldone-btn-light px-4" (click)="backToActions()">Indietro</button>
        </div>
    </ng-container>
</div>
